import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("CANCEL_SL"),
	...createNetworkActions("CREATE_SL"),
	...createNetworkActions("FIND_SL_AVTALER"),
	...createNetworkActions("SET_SLKUNDESAMTYKKE"),
	...createNetworkActions("SET_SLINFORMASJONSAMTYKKE"),
	...createNetworkActions("SET_KUNDE_SAMTYKKE_EPOST"),
};
